
import { createContext } from "react";

import { Species, SpeciesDto, SubSpecies } from "../../api/dtos/dtos";


export interface ISpecies {
    species: Species,
    key?: string;
    subSpecies?: SubSpecies[]; 
    speciesDto?: SpeciesDto
}

export const DEFAULT_SPECIES_CONTEXT: ISpecies = {
    species: Species.None,
    key: undefined,
    subSpecies: undefined,
    speciesDto: undefined
}

interface ISpeciesContext {
    species: ISpecies
}

export const SpeciesContext = createContext<ISpeciesContext>({
    species: DEFAULT_SPECIES_CONTEXT
});